import { TableView } from "@mui/icons-material";
import Button from "e.sic-platform.webclient/src/components/button/Button";
import useThemeService from 'e.sic-platform.webclient/src/services/theme-service/ThemeService';

export default function CsvButton(props: {disabled?: boolean, onClick?(): void}) {
  const { themeClass } = useThemeService();

  return (
    <Button
      id="csv"
      onClick={props.onClick}
      disabled={props.disabled}
      icon={{
        svg: TableView,
        textKey: "general.export.csv",
        textClass: "actions-header-button-label",
        className: themeClass(["icon-mui"]),
      }}
    />
  );
}
